import React from "react";
import { Modal, Typography, Tag, Divider, Row, Col, Space } from "antd";
import {
  NotificationOutlined,
  SendOutlined,
  InfoCircleOutlined,
} from "@ant-design/icons";
import moment from "moment";

const { Title, Text, Paragraph } = Typography;

const ORANGE = "#e2700d";

const ViewNotification = ({ open, onClose, notification }) => {
  if (!notification) return null;

  return (
    <Modal
      open={open}
      onCancel={onClose}
      footer={null}
      centered
      width={650}
      bodyStyle={{ background: "#fff", padding: 24 }}
      closeIcon={<span style={{ color: ORANGE, fontSize: 18 }}>×</span>}
    >
      {/* 🔹 HEADER */}
      <Row gutter={16} align="middle">
        <Col>
          <NotificationOutlined style={{ fontSize: 40, color: ORANGE }} />
        </Col>
        <Col flex="auto">
          <Title level={4} style={{ marginBottom: 0 }}>
            {notification.title}
          </Title>
          <Text type="secondary">{notification.type}</Text>
        </Col>
        <Col>
          <Tag color={notification.status === "DRAFT" ? "orange" : "green"}>
            {notification.status}
          </Tag>
        </Col>
      </Row>

      <Divider />

      {/* 🔹 TARGET */}
      <Space direction="vertical" size={8}>
        <Text strong>
          <SendOutlined /> Target Type
        </Text>
        <Tag color="orange">{notification.target?.type || "N/A"}</Tag>
      </Space>

      <Divider />

      {/* 🔹 MESSAGE */}
      <Text strong>
        <InfoCircleOutlined /> Message
      </Text>
      <Paragraph style={{ marginTop: 8 }}>{notification.message}</Paragraph>

      <Divider />

      {/* 🔹 META INFO */}
      <Row gutter={0}>
        <Col span={12}>
          <Text type="secondary">Created At</Text>
          <div>
            {moment(notification.createdAt).format("DD MMM YYYY, hh:mm A")}
          </div>
        </Col>

        <Col span={12}>
          <Text type="secondary">Last Updated</Text>
          <div>
            {moment(notification.updatedAt).format("DD MMM YYYY, hh:mm A")}
          </div>
        </Col>
      </Row>Home
    </Modal>
  );
};

export default ViewNotification;
